/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
	if (Modernizr.mq('(max-width: 991px)')) {
		$('#mainNav').detach().appendTo('.mobileNav');
		$('#mainNav').attr('aria-hidden', 'true');
		topNavMobile();
	} else {
		$('#mainNav').detach().prependTo('#headerRight');
		$('#mainNav').attr('aria-hidden', 'false');
		topNavReset();
	}
}

function topNavMobile() {
	if (!topNavAdjust) {
		if ($('#topNav').length) {
			$('#topNav').children().detach().appendTo('#nav').wrap('<li class="topNavMobile" />');
		}


		if (!$('#uber').hasClass('landing')) {
			if ($('#headerRight .langToggle').length) {
				$('#headerRight .langToggle').detach().appendTo('#nav').wrap('<li />');
			}
		} else if ($('#uber').hasClass('landing')) {
			if ($('#topNavContainer .backHome').length) {
				$('#topNavContainer .backHome').detach().appendTo('#nav').wrap('<li />');
			}
			if ($('#topNavContainer .langToggle').length) {
				$('#topNavContainer .langToggle').detach().appendTo('#nav').wrap('<li />');
			}
		}

		if ($('#popup .searchContainer').length) {
			$('#popup .searchContainer').detach().appendTo('#nav').wrap('<li />');
		}

		topNavAdjust = true;
	}
}

function topNavReset() {
	if (topNavAdjust) {
		topNavAdjust = false;

		if ($('#uber').hasClass('landing')) {
			if ($('#nav .backHome').length) {
				$('#nav .backHome').unwrap('li').detach().prependTo('#topNavContainer');
			}
			if ($('#nav .langToggle').length) {
				$('#nav .langToggle').unwrap('li').detach().insertAfter('.backHome');
			}
		} else if (!$('#uber').hasClass('landing')) {
			if ($('#nav .langToggle').length) {
				$('#nav .langToggle').unwrap('li').detach().insertAfter('#mainNav');
			}
		}

		if ($('#nav .searchContainer').length) {
			$('#nav .searchContainer').unwrap('li').detach().prependTo('#popup .modal-body');
		}
	}
}

$(window).on('load', function () {
	checkTopNavMobile();
});

//debounce resize instead of standard resize
$(window).on('resize', function () {
	checkTopNavMobile();
});